import { useSelector, useDispatch } from "react-redux";
import { w3cwebsocket } from "websocket";

import { Grid } from "@material-ui/core";

import { RenderNewMessage } from "./actions/Messages";
import { Nuke } from "./api/index";

import Chatfield from "./components/Chatfield/Chatfield";
import Loginfield from "./components/Loginfield/Loginfield";
import ChatViewField from "./components/ChatViewField/ChatViewField";

import "./app.css"

export const client = new w3cwebsocket("wss://scuffedwebsite.com/chat/api/")

const App = () =>
{
  const DeleteMessages = () =>
  {
    Nuke();
  }

  const dispatch = useDispatch();

  client.onmessage = (msg) =>
  {
    dispatch(RenderNewMessage(JSON.parse(msg.data)));
  }

  const user = useSelector((state) => state.user);

  return (
    <div>
      {!user.displayName ? <Loginfield /> : (
        <Grid container style={{ height: "100%" }}>
          <Grid item xs={2} sm={2} lg={2} xl={2}>
            <div>
              <p>
                Sidebar placeholder<br />
                <button onClick={() => DeleteMessages()}>Nuke Log</button>
              </p>
            </div>
          </Grid>
          <Grid item xs={10} sm={10} lg={10} xl={10}>
            <div id="chatWrapper">
              <ChatViewField />
            </div>
            <Chatfield />
          </Grid>
        </Grid>
      )}
    </div>
  )
}

export default App;

